// See note at the top of pool-selector.tsx
// eslint-disable-next-line no-restricted-imports
import styled, { css } from 'styled-components'
import { COLORS } from '~theme/colors'

interface NavButtonProps {
  isSelected?: boolean
  isExternal?: boolean
  isSecondary?: boolean
}

interface Props extends NavButtonProps {
  children: string
}

const BottomBorder = styled.span`
  position: absolute;
  background: ${COLORS.secondary.darkBlue};
  width: 0;
  transition: width 0.3s;
  height: 2px;
  bottom: -6px;
`

const SecondaryBottomBorder = styled(BottomBorder)`
  background: ${COLORS.greys.dark};
`

const Button = styled.button`
  white-space: nowrap;
  letter-spacing: 1.2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${COLORS.secondary.darkBlue};
  font-family: MaerskHeadlineLight;
  position: relative;
  font-size: 0.75rem;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`

const SecondaryButton = styled(Button)`
  color: ${COLORS.greys.dark};
`

const Wrapper = styled.div<{
  $isSelected?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;

  &:focus-visible {
    outline: 2px solid ${COLORS.primary.maerskBlue};
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      ${BottomBorder} {
        background: ${COLORS.secondary.barBlue};
        width: 100%;
      }

      ${SecondaryBottomBorder} {
        width: 100%;
        background: ${COLORS.greys.dark};
      }

      ${Button} {
        color: ${COLORS.secondary.barBlue};
      }

      ${SecondaryButton} {
        color: ${COLORS.greys.dark};
      }
    `}

  ${Button} {
    &:hover {
      color: ${COLORS.secondary.barBlue};
    }
  }
  ${SecondaryButton} {
    &:hover {
      color: ${COLORS.greys.mid};
    }
  }
`

function NavButton({ isSelected, children }: Props) {
  return (
    <Wrapper tabIndex={0} $isSelected={isSelected}>
      <Button tabIndex={-1}>
        {children}
        <BottomBorder />
      </Button>
    </Wrapper>
  )
}

NavButton.displayName = 'NavButton'

export default NavButton
